import {
  ADD_ATTENDER_FAILURE,
  ADD_ATTENDER_REQUEST,
  ADD_ATTENDER_SUCCESS,
  DELETE_ATTENDER_FAILURE,
  DELETE_ATTENDER_REQUEST,
  DELETE_ATTENDER_SUCCESS,
  FETCH_ATTENDER_FAILURE,
  FETCH_ATTENDER_REQUEST,
  FETCH_ATTENDER_SUCCESS,
  FETCH_LIST_ATTENDER_FAILURE,
  FETCH_LIST_ATTENDER_REQUEST,
  FETCH_LIST_ATTENDER_SUCCESS,
  HISTORY_ATTENDER_FAILURE,
  HISTORY_ATTENDER_REQUEST,
  HISTORY_ATTENDER_SUCCESS,
  RESET_CURRENT_ATTENDER,
  UPDATE_ATTENDER_FAILURE,
  UPDATE_ATTENDER_REQUEST,
  UPDATE_ATTENDER_SUCCESS,
} from "./attenderType";

export const fetchAttender = () => ({
  type: FETCH_LIST_ATTENDER_REQUEST,
});

export const fetchAttenderSuccess = (attender) => {
  return {
    type: FETCH_LIST_ATTENDER_SUCCESS,
    payload: { attender },
  };
};

export const fetchAttenderFailure = (error) => ({
  type: FETCH_LIST_ATTENDER_FAILURE,
  payload: { error },
});

export const fetchHistoryAttender = (id) => ({
  type: HISTORY_ATTENDER_REQUEST,
  payload: id,
});

export const fetchHistoryAttenderSuccess = (attender) => ({
  type: HISTORY_ATTENDER_SUCCESS,
  payload: { attender },
});

export const fetchHistoryAttenderFailure = (error) => ({
  type: HISTORY_ATTENDER_FAILURE,
  payload: { error },
});


export const fetchAttenderMember = (staffId,patientId) => ({
  type: FETCH_ATTENDER_REQUEST,
  payload: { staffId,patientId },
});

export const fetchAttenderMemberSuccess = (attender) => ({
  type: FETCH_ATTENDER_SUCCESS,
  payload: { attender },
});

export const fetchAttenderMemberFailure = (error) => ({
  type: FETCH_ATTENDER_FAILURE,
  payload: { error },
});


export const addAttender = (attenderData) => {
  return {
    type: ADD_ATTENDER_REQUEST,
    payload: attenderData,
  };
};

export const addAttenderSuccess = (attender) => {
  return {
    type: ADD_ATTENDER_SUCCESS,
    payload: { attender },
  };
};

export const addAttenderFailure = (error) => {
  return {
    type: ADD_ATTENDER_FAILURE,
    payload: { error },
  };
};


export const updateAttender = (attenderId, attenderData) => {

  return {
    type: UPDATE_ATTENDER_REQUEST,
    payload: { attenderId, attenderData },
  };
};

export const updateAttenderSuccess = (attender) => ({
  type: UPDATE_ATTENDER_SUCCESS,
  payload: { attender },
});

export const updateAttenderFailure = (error) => ({
  type: UPDATE_ATTENDER_FAILURE,
  payload: { error },
});


export const deleteAttender = (attenderId) => ({
  type: DELETE_ATTENDER_REQUEST,
  payload: { attenderId },
});

export const deleteAttenderSuccess = (attenderId) => ({
  type: DELETE_ATTENDER_SUCCESS,
  payload: { attenderId },
});

export const deleteAttenderFailure = (error) => ({
  type: DELETE_ATTENDER_FAILURE,
  payload: { error },
});


export const resetCurrentAttender = () => ({
  type: RESET_CURRENT_ATTENDER,
});